<template>
  <div class="flex flex-col">
    <div class="flex flex-1">
      <slot />
    </div>
    <footer class="py-8 bg-ocean-950 hidden lg:block">
      <p class="w-full max-w-7xl text-right mx-auto text-white/50 opacity-4 px-standard font-normal text-sm">
        ©{{ new Date().getFullYear() }} Vetster, Inc. {{ $t('footer.all-rights-reserved') }}.
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'VetsterCommonLayout',
};
</script>
